import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

function RutaPrivada({ children, rolEsperado }) {
  const { user, loading } = useContext(AuthContext);

  // 1. Mientras se verifica la sesión, mostramos un estado de carga
  // Esto evita que React redirija antes de saber si el usuario existe
  if (loading) {
    return (
      <div style={{ 
        backgroundColor: '#000', 
        height: '100vh', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        color: '#ff0000',
        fontSize: '1.2rem'
      }}>
        Verificando sesión...
      </div>
    );
  }

  // 2. Si NO hay usuario logueado:
  // Lo mandamos a la INTRO de su respectivo rol (Admin o Delivery)
  if (!user) {
    const destino = rolEsperado === 'delivery' ? "/delivery-intro" : "/admin-intro";
    return <Navigate to={destino} replace />;
  }

  // 3. Si el rol NO coincide:
  // Si un Delivery intenta entrar a /admin, lo devolvemos a su panel /delivery
  if (user.rol !== rolEsperado) {
    console.warn(`🚫 Acceso denegado. Rol: ${user.rol}, Requerido: ${rolEsperado}`);
    const homeCorrecta = user.rol === 'admin' ? "/admin" : "/delivery";
    return <Navigate to={homeCorrecta} replace />;
  }

  // 4. Si todo está bien, renderizamos el contenido (Navbar + Panel)
  return children;
}

export default RutaPrivada;